import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01e7a57e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invest-tabel" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invest-tabel-title" }, "会员报名表", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("提交申请")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("返回修改")
const _hoisted_5 = {
  key: 0,
  class: "fd-status status1"
}
const _hoisted_6 = {
  key: 1,
  class: "fd-status status2"
}

import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive, watch } from "vue";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";
import Bottom from "../components/bottom.vue";
import { MoreFilled } from "@element-plus/icons-vue";

import tool from "@/utils/tool";
import router from "@/router/index";
import { Plus } from "@element-plus/icons-vue";
import type {
  UploadFile,
  ElFile,
} from "element-plus/es/components/upload/src/upload.type";

type FormInstance = InstanceType<typeof ElForm>;

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isEdit = ref(false);
const activitiesStep = [
  {
    content: "提交申请",
    timestamp: "2018-04-12 20:46",
    size: "large",
    type: "primary",
    icon: MoreFilled,
  },
  {
    content: "审核",
    timestamp: "2018-04-03 20:46",
    color: "#0bbd87",
  },
  {
    content: "结果",
    timestamp: "2018-04-03 20:46",
    size: "large",
  },
];

const activityApplyEvent = () => {
  var id = router.currentRoute.value.params.id;
  if (typeof id == "string") {
    store
      .dispatch("frontInvestModule/getActivityApply", { activityId: id })
      .then(
        (data) => {
          //成功
          if (data.result != null) {
            bindData.type = data.result.type;
            if(data.result.id){
              bindData.activityApplyForm = data.result;
              bindData.auditStatus = data.result.auditStatus;
              if (!data.result.auditStatus && data.result.auditStatus != 0) {
                bindData.activeIndex = 0;
              } else {
                bindData.activeIndex = data.result.auditStatus + 1;
              }
              if (bindData.activeIndex > 1) {
                bindData.activeIndex = 3;
              }
              if (
                data.result.auditStatus != null &&
                data.result.auditStatus >= 0
              ) {
                isEdit.value = true;
              } else {
                isEdit.value = false;
              }

              bindData.activityApplyForm.joinCategoryIdsArray =
                data.result.joinCategoryIds.split(",");
              }
          }
        },
        (error) => {
          console.log(error.msg);
        }
      );
  }
};

const deleteActivityApplyEvent = () => {
  var id = router.currentRoute.value.params.id;
  if (typeof id == "string") {
    store
      .dispatch("frontInvestModule/deleteActivityApply", { activityId: id })
      .then(
        (data) => {
          activityApplyEvent();
          ElMessage.success("返回成功.");
        },
        (error) => {
          console.log(error.msg);
        }
      );
  }
};

activityApplyEvent();

store.dispatch("frontInvestModule/listJoinCategory", {}).then(
  (data) => {
    //成功
    if (data.result != null) {
      bindData.joinCategoryList = data.result;
    }
  },
  (error) => {
    console.log(error.msg);
  }
);

const activityApplyFormRef = ref<FormInstance>();

const ustore = useStore();

const bindData = reactive({
  type: 0,
  memberName: "",
  activeIndex: 0,
  auditStatus: 0,
  joinCategoryList: [],
  activityApplyForm: {
    id: "",
    activityId: "",
    contact: "",
    mobile: "",
    explanation: "",
    joinCategoryIdsArray: [],
    joinCategoryIds: "",
    applyTime: "",
    cost: 0.00,
    isPayed:"N",
  },
});

var id = router.currentRoute.value.params.id;
if (typeof id == "string") {
  bindData.activityApplyForm.activityId = id;
}

bindData.memberName =
  ustore.state.loginMember == undefined
    ? ""
    : ustore.state.loginMember.companyName;

bindData.activityApplyForm.contact =
  ustore.state.loginMember == undefined ? "" : ustore.state.loginMember.name;

bindData.activityApplyForm.mobile =
  ustore.state.loginMember == undefined ? "" : ustore.state.loginMember.mobile;

watch(
  () => ustore.state.loginMember,
  (newValue: any, oldValue: any) => {
    bindData.memberName = newValue.companyName;
    bindData.activityApplyForm.contact = newValue.name;
    bindData.activityApplyForm.mobile = newValue.mobile;
  }
);

const defaultValidate = (rule: any, value: any, callback: any) => {
  if (value === "") {
    callback(new Error("请填写联系人"));
  } else {
    callback();
  }
};

const activityApplyRules = reactive({
  contact: [{ required: true, validator: defaultValidate, trigger: "blur" }],
  mobile: [{ required: true, message: "请填写电话", trigger: "blur" }],
  joinCategoryIdsArray: [
    { required: true, message: "请选择意向品类", trigger: "change" },
  ],
});

const submitForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      bindData.activityApplyForm.joinCategoryIds =
        bindData.activityApplyForm.joinCategoryIdsArray.join(",");
      store
        .dispatch(
          "frontInvestModule/saveActivityApply",
          bindData.activityApplyForm
        )
        .then(
          (data) => {
            //成功
            activityApplyEvent();
            ElMessage.success("保存成功.");
            if (bindData.activityApplyForm.cost >= 0.01 && bindData.activityApplyForm.isPayed=="N") {
              router.push("/frontDesk/applyPayment/" + bindData.activityApplyForm.activityId);
            }
            else {
              router.push("/frontDesk/applySuccess/" + bindData.activityApplyForm.activityId);
            }
          },
          (error) => {
            ElMessageBox.alert(error.msg, "系统消息", {
              confirmButtonText: "关闭",
              callback: (action: Action) => { },
            });
          }
        );
    } else {
      console.log("error submit!");
      return false;
    }
  });
};

const resetForm = (formEl: FormInstance | undefined) => {
  console.log("exec...resetForm");
  if (!formEl) return;
  formEl.resetFields();
};

return (_ctx: any,_cache: any) => {
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_el_steps, {
        active: _unref(bindData).activeIndex,
        "finish-status": "success"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(activitiesStep, (activityStep, index) => {
            return _createVNode(_component_el_step, {
              key: index,
              title: activityStep.content
            }, null, 8, ["title"])
          }), 64))
        ]),
        _: 1
      }, 8, ["active"]),
      _createVNode(_component_el_form, {
        class: "invest-tabel-ct",
        model: _unref(bindData).activityApplyForm,
        ref_key: "activityApplyFormRef",
        ref: activityApplyFormRef,
        "label-width": "120px",
        "status-icon": "",
        rules: _unref(activityApplyRules)
      }, {
        default: _withCtx(() => [
          (_unref(bindData).type!=8)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "意向品类",
                prop: "joinCategoryIdsArray"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_checkbox_group, {
                    modelValue: _unref(bindData).activityApplyForm.joinCategoryIdsArray,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(bindData).activityApplyForm.joinCategoryIdsArray) = $event)),
                    disabled: isEdit.value
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).joinCategoryList, (joinCategory) => {
                        return (_openBlock(), _createBlock(_component_el_checkbox, {
                          key: joinCategory.id,
                          label: joinCategory.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(joinCategory.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: "会员名称",
            prop: "memberName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(bindData).memberName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(bindData).memberName) = $event)),
                disabled: "",
                "input-style": "width:300px",
                placeholder: "",
                size: "default"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "意向说明",
            prop: "explanation"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                "input-style": "width:500px",
                modelValue: _unref(bindData).activityApplyForm.explanation,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(bindData).activityApplyForm.explanation) = $event)),
                disabled: isEdit.value,
                type: "textarea",
                autosize: { minRows: 4, maxRows: 8 },
                autocomplete: "off"
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "联系人",
            prop: "contact"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(bindData).activityApplyForm.contact,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(bindData).activityApplyForm.contact) = $event)),
                disabled: isEdit.value,
                "input-style": "width:300px",
                placeholder: "",
                size: "default"
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "电话",
            prop: "mobile"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(bindData).activityApplyForm.mobile,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(bindData).activityApplyForm.mobile) = $event)),
                disabled: isEdit.value,
                "input-style": "width:300px",
                placeholder: "",
                size: "default"
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          (_unref(bindData).activeIndex > 0)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 1,
                label: "申请时间",
                prop: "applyTime"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(bindData).activityApplyForm.applyTime,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(bindData).activityApplyForm.applyTime) = $event)),
                    disabled: isEdit.value,
                    "input-style": "width:300px",
                    placeholder: "",
                    size: "default"
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["model", "rules"]),
      _createVNode(_component_el_container, { class: "invest-tabel-btn" }, {
        default: _withCtx(() => [
          (_unref(bindData).activeIndex == 0)
            ? (_openBlock(), _createBlock(_unref(ElButton), {
                key: 0,
                type: "primary",
                size: "large",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (submitForm(activityApplyFormRef.value)))
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(bindData).activeIndex == 1)
            ? (_openBlock(), _createBlock(_unref(ElButton), {
                key: 1,
                type: "info",
                onClick: deleteActivityApplyEvent,
                size: "large"
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_unref(bindData).auditStatus == '1')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "已通过"))
        : _createCommentVNode("", true),
      (_unref(bindData).auditStatus == '2')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, "已拒绝"))
        : _createCommentVNode("", true)
    ]),
    _createVNode(Bottom)
  ]))
}
}

})